import React from 'react';
import PropTypes from 'prop-types';
import { CameraIcon } from 'shared';
import './preview.scss';

const getImage = ( file, avatarUrl, userInitials ) => {
    if ( file && file.preview ) {
        return <img alt="preview" src={ file.preview } />;
    } else if ( avatarUrl ) {
        return <img alt="avatar" src={ avatarUrl } />;
    } else {
        return <div className="user-initials client-primary-text">{ userInitials }</div>;
    }
};
export const AvatarPreview = ( { file, avatarUrl, userInitials } ) =>  { return ( <div className="preview-container">
        <div className="preview">
            { getImage( file, avatarUrl, userInitials ) }
        </div>
        <div className="camera-icon"><CameraIcon /></div>
    </div> );
};


AvatarPreview.propTypes = {
    file: PropTypes.shape( {
        preview: PropTypes.string
     } ),
    avatarUrl: PropTypes.string,
    userInitials: PropTypes.string
};
AvatarPreview.defaultProps = {
    avatarUrl: null
};
export default AvatarPreview;